import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import GAListener from 'components/common/GoogleAnalyticsHOC';
import ErrorBouncer from 'components/common/ErrorBouncer';
import { hot } from 'react-hot-loader/root';
import LoadingPage from 'components/common/LoaddingPage';
import Loadable from 'react-loadable';

const Auth = Loadable({
    loader: () => import('modules/auth/containers/AuthContainer'),
    loading: LoadingPage,
});

const SelectCompany = Loadable({
    loader: () => import('modules/auth/containers/SelectCompanyContainer'),
    loading: LoadingPage,
});

const TransportOrderElec = Loadable({
    loader: () => import('modules/transport-orders-elec-template'),
    loading: LoadingPage,
});

const Layout = Loadable({
    loader: () => import('components/layout'),
    loading: LoadingPage,
});

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer,
    };
};

const AuthComponent = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                if (!rest.auth.user) {
                    return (
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: { from: props.location },
                            }}
                        />
                    );
                }

                if (!rest.auth.user.active_super_company && rest.auth.user.org_id === 0 && rest.auth.loggedInFirebase) {
                    return <SelectCompany />;
                }

                return <Component {...props} />;
            }}
        />
    );
};

const AuthContainer = connect(mapStateToProps, null)(AuthComponent);

class App extends React.Component {
    render() {
        return (
            <Router>
                <GAListener>
                    <ErrorBouncer>
                        <Switch>
                            <Route exact path="/login" component={Auth} />;
                            <Route exact path="/reset-password" component={Auth} />;
                            <Route exact path="/transport-orders-elec-template" component={TransportOrderElec} />;
                            <AuthContainer path={'/'} component={Layout} />
                        </Switch>
                    </ErrorBouncer>
                </GAListener>
            </Router>
        );
    }
}

export default module.hot ? hot(App) : App;
